var _path, _rect, _rect2, _rect3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 46,
    height: 29,
    viewBox: "0 0 46 29",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.7899 16.7962L22.13 22.2571L27.7011 27.0557L43.8464 2.6953L15.7899 16.7962ZM40.3643 3.01282L7.70048 9.82852L14.7396 15.8915L40.3643 3.01282ZM44.8129 0.776987L6.54232 8.76261C5.87046 8.90281 5.65103 9.75261 6.17108 10.2005L14.2116 17.1261V26.3709C14.2116 27.0081 14.9011 27.4065 15.4531 27.0883L21.6386 23.5232L27.2543 28.3601C27.632 28.6855 28.2094 28.6057 28.4848 28.1902L45.8356 2.01088C46.2442 1.3944 45.7011 0.592504 44.9773 0.742681L44.9579 0.704102L44.8129 0.776987ZM15.4916 25.5887V18.2286L20.611 22.6381L15.4916 25.5887Z",
    fill: "#01285F"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 12.9448,
    height: 1.15425,
    rx: 0.577124,
    transform: "matrix(0.898919 -0.438115 0.504089 0.863652 -0.177734 23.5829)",
    fill: "#B8341B"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 7.12865,
    height: 1.15425,
    rx: 0.577124,
    transform: "matrix(0.898919 -0.438115 0.504089 0.863652 4.71094 25.0181)",
    fill: "#B8341B"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 2.351,
    height: 1.15425,
    rx: 0.577124,
    transform: "matrix(0.898919 -0.438115 0.504089 0.863652 9.04297 26.3334)",
    fill: "#B8341B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.ff0e2fa5c0706ef1694f76d47a516336.svg";
export { ForwardRef as ReactComponent };